import { createStyles } from 'antd-style';

export const useStyles = createStyles(({ token, css }) => {
  return {
    logo: css`
      display: flex;
      align-items: center;
      padding-top: 10px;
      box-sizing: border-box;
      border-bottom: 1px solid rgba(250, 250, 250, 1);
      padding-left: 20px;
      padding-bottom: 18px;
      padding-top: 18px;
    `,
    title: css`
      margin-left: 8px;
    `
  };
});
